// extracted by mini-css-extract-plugin
export default {"list":"ColumnTasksList_list__yUeIZ"};